// import { WZUtils } from "../common/globals";

// 域名配置、路径相关配置
export const HOST_NAME = location.hostname
const PYDP888_COM = 'pydp888.com'
const IWANGZHE_COM = 'iwangzhe.com'
export const ENV_MODE = /dev\./.test(HOST_NAME) ? 'dev' : /test\./.test(HOST_NAME) ? 'test' : 'prd'

export const HOST_STATIC = `staticcdn-${ENV_MODE}.${PYDP888_COM}`
export const HOST_API = ENV_MODE === 'dev' ? `api-dev.${PYDP888_COM}` : ENV_MODE === 'test' ? `api-test.${IWANGZHE_COM}` : `api.${IWANGZHE_COM}`
export const HOST_WEB = ENV_MODE === 'dev' ? `dev.${PYDP888_COM}` : ENV_MODE === 'test' ? `test.${IWANGZHE_COM}` : `${IWANGZHE_COM}`
export const HOST_BBS = ENV_MODE === 'dev' ? `bbs-dev.${PYDP888_COM}` : ENV_MODE === 'test' ? `bbs-test.${IWANGZHE_COM}` : `bbs.${IWANGZHE_COM}`
export const HOST_PASSPORT = ENV_MODE === 'dev' ? `passport-dev.${PYDP888_COM}` : ENV_MODE === 'test' ? `passport-test.${IWANGZHE_COM}` : `passport.${IWANGZHE_COM}`

// export const DIR_RES = `https://${HOST_STATIC}/award/kline/sale/201811/`
// export const DIR_CSS = `${DIR_RES}css/`
// export const DIR_IMG = `https://${HOST_STATIC}/award/kline/sale/img/201811/`

// export const URL_DOWLOAD = `https://${HOST_WEB}/download/?_fr=sinawzlesson`
// export const URL_KLINE = `https://${HOST_WEB}/award/klinev2/?_fr=sinawzlesson`


// 奖励
export const REWARD_TYPE_PRE = 1
export const REWARD_TYPE_FINAL = 2

// 第三方登录
export const OAUTH_PLAT_WEIBO = 1
export const OAUTH_PLAT_WEIXIN = 2
export const OAUTH_PLAT_QQ = 3
export const OAUTH_PLAT_HEXUN = 4
export const OAUTH_NAME_WEIBO = 'weibo'
export const OAUTH_NAME_WEIXIN = 'weixin'
export const OAUTH_NAME_QQ = 'qq'
export const OAUTH_NAME_HEXUN = 'hexun'

// 状态相关配置 status
export const ST_UNKNOWN = -1
export const ST_SIGN_WAIT = 10  // 报名：未开始
export const ST_SIGN_ING = 11  // 报名：进行中
export const ST_SIGN_END = 20  // 报名：已结束

export const ST_PRE_WAIT = 20  // 预赛：报名结束、预赛未开始
export const ST_PRE_ING = 21  // 预赛：进行中
export const ST_PRE_END = 22  // 预赛：已结束
export const ST_PRE_RESULT = 30  // 预赛：结果公布

export const ST_FINAL_WAIT = 30  // 决赛：未开始（初赛已公布）
export const ST_FINAL_ING = 31  // 决赛：进行中
export const ST_FINAL_END = 32  // 决赛：已结束
export const ST_FINAL_RESULT = 33  // 决赛：结果公布

export const ST_ACTION_NONE = 0 // 无结果
export const ST_ACTION_RESULT = 1 // 有结果

/*
错误码定义

4*****: Api请求类错误
5*****: App对接类错误

Api请求错误： 参数，路径等错误 
41Xxx： 通用参数错误
41XxxYyy{3,5}：Yyy为协议编号长度3至5位，不够3位的协议号前面补零

Api响应错误（超时，返回数据非法等）
1xxxx，2xxxx: 后端返回的错误码，目前固定1或2开头的5位数字
42Xxx： 通用响应错误
42XxxYyy{3,5}：特定协议响应错误，Yyy为协议编号，长度3至5位

App请求错误（参数，路径等错误）
51Xxx： 通用参数错误码
51XxxYyy{3,5}：特定Api请求错误

App响应错误：超时，返回数据非法等
52Xxx： 通用响应错误
52XxxYyy{3,5}：特定协议响应错误

上述编号的格式中：
Xxx： 表示错误编号，3位长度
Yyy{3,5}：表示协议编号，长度3至5位，不够3位的协议号前面补零

*/
export const ERR_REQ = 41000
export const ERR_REQ_UID = 41001
export const ERR_REQ_CUP_ID = 41002
export const ERR_REQ_GAME_ID = 41003
export const ERR_REQ_KID = 41004
export const ERR_REQ_CID = 41005
export const ERR_REQ_TYPE = 41006

export const ERR_REP = 42000
export const ERR_REP_MY_INFO = 42001
export const ERR_REP_CUP_INFO = 42002
export const ERR_REP_GAME_INFO = 42003
export const ERR_REP_KLINES = 42004
export const ERR_REP_ACTION = 42005
export const ERR_REP_CUP_PLAYER = 42006
export const ERR_REP_CONFIG = 42007
export const ERR_REP_GAME_LIST = 42008
export const ERR_REP_CUP_PLAYER_LIST = 42009
export const ERR_REP_OAUTH_ADDRESS = 42010

export const ERR_REP_MY_DETAIL = 42011
export const ERR_REP_RANK_LIST = 42012
export const ERR_REP_ADDRESS_LIST = 42020

export const ERR_REP_NOT_LOGIN = 10018

// 动作
// export const LOAD_CONFIG = 'loadConfig'
// export const LOAD_MY_INFO = 'loadMyInfo'
// export const LOAD_MY_DETAIL = 'loadMyDetail'
// export const LOAD_GAME = 'loadGame'
// export const LOAD_GAMES = 'loadGames'

// export const LOAD_REALITY_CUP_ID = 'loadRCupId'
